import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { BillingPeriod } from '@/hooks/useSubscription';

export interface PlanPricing {
  monthly: number;
  annual: number;
}

const DEFAULTS: PlanPricing = { monthly: 29.9, annual: 299.0 };

export function usePlanPricing() {
  const { data, isLoading } = useQuery({
    queryKey: ['plan-pricing'],
    queryFn: async (): Promise<PlanPricing> => {
      const { data, error } = await supabase
        .from('plan_pricing' as any)
        .select('billing_period, price');
      if (error || !data) return DEFAULTS;
      const map: PlanPricing = { ...DEFAULTS };
      (data as any[]).forEach((row) => {
        if (row.billing_period === 'monthly') map.monthly = Number(row.price);
        if (row.billing_period === 'annual') map.annual = Number(row.price);
      });
      return map;
    },
    staleTime: 60_000,
  });

  const pricing = data ?? DEFAULTS;
  const priceFor = (period: BillingPeriod) =>
    period === 'annual' ? pricing.annual : pricing.monthly;

  return { pricing, priceFor, loading: isLoading };
}
